import React, { useCallback, useMemo, useState } from 'react';
import { message, Popover } from 'antd';

import Cascader from '../cascader';

import { useConvTag } from '@/store';
import TagSelect from '../tag-select';

const { SHOW_PARENT } = Cascader;

export type ConvTagType = {
  id: number;
  level: number;
  parentId?: number;
  tag_name: string;
  color: string;
};

type OpeTagProps = {
  children: React.ReactChildren | React.ReactChild;
  convTags: Array<ConvTagType>;
  onSelect: (ids: number[]) => void;
  convTagMaxWidth?: number;
  handleSetConvTagWidth?: () => void;
  customerRenderNode?: (label: string, value: string, item: TagNodeItem) => React.ReactNode;
  hasQuantityLimit?: boolean;
};

type TagNodeItem = {
  color: string;
};

const ConvTag: React.FC<OpeTagProps> = ({
  convTags,
  onSelect,
  children,
  handleSetConvTagWidth,
  hasQuantityLimit = true
}) => {
  const [visible, setVisible] = useState(false);
  const { convTagTree } = useConvTag();

  const value = useMemo(() => {
    return convTags.map(item => item.id);
  }, [convTags]);

  const onClick = useCallback(e => {
    e?.stopPropagation();
    setVisible(true);
  }, []);

  const onVisibleChange = useCallback(
    e => {
      if (visible && !e) {
        setVisible(false);
      }
      if (e && handleSetConvTagWidth) {
        handleSetConvTagWidth();
      }
    },
    [visible, handleSetConvTagWidth]
  );

  const handleSelect = (ids: number[]) => {
    if (ids.length >= 10) {
      return message.warning('一条对话仅可添加10个对话标签');
    }
    onSelect(ids);
  };

  return (
    <Popover
      open={visible}
      onOpenChange={onVisibleChange}
      trigger='click'
      arrowPointAtCenter={false}
      placement='bottomLeft'
      content={<TagSelect alwaysOpen multiple data={convTagTree} value={value} onChange={handleSelect} />}
    >
      {React.Children.map(children, child => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return React.cloneElement(child, {
          onClick
        });
      })}
    </Popover>
  );
};

export default ConvTag;
